import useDeviationPermissions from "../usePermissions";

const useIsReadOnly = () => {
  const { isSalaryAdmin, isBusinessUnitManagerWithSalaryRights, isDeviationAdmin } = useDeviationPermissions();
  const getIsReadOnly = (options: {
    hasConnectedTimeReports?: boolean;
    isAdminOnlyType: boolean;
    isMonthDisabled: boolean;
  }) => {
    const typeAllowed =
      isSalaryAdmin || isDeviationAdmin || isBusinessUnitManagerWithSalaryRights || !options.isAdminOnlyType;
    const isReadOnly = options.isMonthDisabled || options.hasConnectedTimeReports || !typeAllowed;

    return isReadOnly;
  };

  return { getIsReadOnly };
};

export default useIsReadOnly;
